import CloseIcon from '@mui/icons-material/Close';
import { Avatar, AvatarGroup, Box, Checkbox, Collapse, Divider, Paper, Stack, Typography, useTheme } from '@mui/material';
import { parseCronExpression } from 'cron-schedule';
import _ from 'lodash';
import moment from 'moment';
import { useState } from 'react';
import { useDrop } from 'react-dnd';
import { lighter } from '../../common/util';
import ActivityCard from '../../enrollment/activity.card';
import { activityApi } from "../../enrollment/activity.queries";
import StudentName from '../../student/student.name';
import todoService from '../../todo/todo.service';

export default function MonthlyDay(props) {
	const useUpdate = activityApi.useUpdate();
	const theme = useTheme();
	let { date, activities, todos, groupBy, isHoliday } = props;
	const [expand, setExpand] = useState({});//Expand is current state
	const [expanded, setExpanded] = useState({});//Expanded is "if ever been expanded"

	const [dropProps, drop] = useDrop(() => ({
		accept: 'activity',
		drop: (activity) => moveActivity(activity),
		collect: (monitor) => ({
			isOver: !!monitor.isOver()
		})
	}));

	const moveActivity = async (activity) => {
		if (activity?.id && !date.isSame(activity.startDate, 'date')) {
			activity.startDate = date.valueOf();
			await useUpdate.mutateAsync(activity);
		}
	}

	const toggleExpand = (key) => {
		expand[key] = !expand[key];
		setExpand({ ...expand });

		expanded[key] = true;
		setExpanded({ ...expanded });
	}

	activities = activities?.filter(activity => {
		let include = moment(date).isSame(moment(activity.startDate), 'date');
		include = include || (moment(date).isSameOrAfter(moment(activity.startDate), 'date') && moment(date).isSameOrBefore(moment(activity.endDate), 'date') && !isHoliday);
		include = include && !activity.courseDetail?.isParent;
		if (activity?.enrollment?.schedule) {
			const cron = parseCronExpression(activity?.enrollment?.schedule);
			include = include && (cron.matchDate(date.toDate()) || moment(date).isSame(moment(activity.startDate), 'date'));
		}
		return include;
	});

	const updateActivity = (updated) => {
		const existing = _.find(activities, { id: updated.id });
		if (existing) {
			const index = _.indexOf(activities, existing);
			activities.splice(index, 1, updated);
		}
	};

	const onToggleTodoComplete = async (todo) => {
		todo.complete = !todo.complete;
		await todoService.save(todo);
	};

	const results = [];

	const getBoxStyles = (activity, colour) => {
		colour = colour || activity?.courseDetail?.course?.colour || activity?.courseDetail?.course?.subject?.colour || '#81c784';
		const styles = {
			mx: props.showScore ? 0 : -1,
			mb: 1,
			px: 0.5,
			py: 1,
			border: '1px solid ' + colour,
			backgroundColor: lighter(colour, 0.8, theme),
			'&:last-child': {
				// borderBottomLeftRadius: 4,
			},
		};
		if (!props.showScore) {
			styles.borderRight = 'none';
		}
		return styles;
	};

	if (groupBy == 'course') {
	}
	else { //Student by default
		const renderStudent = (activities, i) => {
			const activity = activities[0];
			const student = activity?.enrollment?.student;
			const groups = _.groupBy(activities, 'courseDetail.courseId');

			return (
				<Box key={student?.id} sx={{ pb: 1 }}>
					{i > 0 && <Box sx={{ mt: 2 }} />}
					{props.showStudent != false && <Box sx={[getBoxStyles(activity, student?.colour), props.showScore ? {} : { borderLeft: 'none' }]}>
						<StudentName student={student} size={24} variant="h5" />
					</Box>}
					<Stack direction="column">
						{Object.keys(groups).map(key => {
							const group = groups[key];
							const colour = group[0]?.courseDetail?.course?.colour || group[0]?.courseDetail?.course?.subject?.colour;
							const first = group.shift();
							const positionSx = {
								position: 'absolute',
								top: -8,
								right: -8,
								cursor: 'pointer',
							};
							const avatarGroupSx = {
								'> *': {
									borderWidth: '0 !important',
									height: '24px !important',
									width: '24px !important',
									fontSize: '12px !important',
									backgroundColor: (colour || theme.palette.info.main) + ' !important',
								}
							};
							const avatarSx = {
								height: 24,
								width: 24,
								backgroundColor: (colour || theme.palette.info.main),
								'> *': {
									height: 16,
									width: 16,
								}
							};

							return (
								<Box key={key} className="hover-toggle">
									<Box sx={{ position: 'relative' }} className="hover-subtle">
										{expand[student?.id + key] != true && <AvatarGroup total={group.length} sx={[positionSx, avatarGroupSx]} onClick={() => toggleExpand(student?.id + key)} />}
										{expand[student?.id + key] == true && <Avatar sx={[positionSx, avatarSx]} onClick={() => toggleExpand(student?.id + key)}><CloseIcon /></Avatar>}
									</Box>
									<ActivityCard activity={first} date={date} variant="dense" hideScore={!props.showScore} hideStudent={true} />
									<Collapse in={expand[student?.id + key]}>
										<Stack direction="column" sx={{ mt: 1 }} spacing={1}>
											{group.map((activity, i) =>
												<ActivityCard activity={activity} date={date} variant="dense" hideScore={true} hideStudent={true} hideCourse={true} key={activity.id} />
											)}
										</Stack>
									</Collapse>
								</Box>
							);
						})}
					</Stack>
				</Box>
			);
		};

		activities = _.orderBy(activities, ['enrollment.student.name', 'courseDetail.course.subject.name', 'courseDetail.course.name', 'courseDetail.ordinal']);
		const groups = _.groupBy(activities, activity => activity.enrollment?.student?.name);

		Object.keys(groups).map((key, i) => (
			results.push(renderStudent(groups[key], i))
		));
	}

	return (
		<Paper elevation={0} sx={{ minHeight: 150, p: 0, backgroundColor: dropProps.isOver ? '#81c78422' : 'transparent' }} ref={drop}>
			{todos?.length > 0 && todos.map((todo) => (
				<Box key={todo.id}>
					<Checkbox sx={{ p: 0.25, pr: 0.5 }} defaultChecked={todo.complete} onClick={() => onToggleTodoComplete(todo)} />
					<Typography variant="small" sx={{ textDecoration: todo.complete ? 'line-through' : '', }}>{todo.item}</Typography>
					<Divider />
				</Box>
			))}
			{results}
		</Paper>
	);
}
